import React from "react";
import { Button, DatePicker, Modal, Select, Space, Input, Form } from "antd";
import { Option } from "antd/es/mentions";

export const UserFilters = ({ form, isModalOpen, handleCancel, setFilterForm, filterForm, handleFilter }) => {

  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        >
          <Form.Item
            name="name"
            className="subscription-plan"
            rules={[{ required: true, message: "Please enter the name!" }]}
          >
            <Input
              value={filterForm?.name}
              onChange={(e) => setFilterForm({ ...filterForm, name: e.target.value })}
              size="large"
              placeholder="Filter by name"
            />
          </Form.Item>

          {/* Email Filter */}
          <Form.Item
            name="email"
            className="subscription-plan"
            rules={[{ required: true, message: "Please enter the email!" }]}
          >
            <Input
              value={filterForm?.email}
              onChange={(e) => setFilterForm({ ...filterForm, email: e.target.value })}
              size="large"
              placeholder="Filter by email"
            />
          </Form.Item>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Form.Item
            name="phone"
            className="subscription-plan"
            rules={[{ required: true, message: "Please enter the phone!" }]}
          >
            <Input
              value={filterForm?.phone}
              onChange={(e) => setFilterForm({ ...filterForm, phone: e.target.value })}
              size="large"
              placeholder="Filter by phone"
            />
          </Form.Item>

          <Form.Item name="status" className="subscription-plan">
            <Select
              value={filterForm?.status}
              onChange={(value) => setFilterForm({ ...filterForm, status: value })}
              placeholder="Filter by status"
              style={{ marginTop: "0.5rem", width: "99%" }}
              options={[
                { value: "0", label: "Inactive" },
                { value: "1", label: "Active" },
              ]}
            />
          </Form.Item>

        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="status" className="subscription-plan">
            <Select
              value={filterForm?.status}
              onChange={(value) => setFilterForm({ ...filterForm, status: value })}
              placeholder="Filter by status"
              style={{ marginTop: "0.5rem", width: "99%" }}
              options={[
                { value: "0", label: "Inactive" },
                { value: "1", label: "Active" },
              ]}
            />
          </Form.Item>
        </div>

        {/* Optional Date Range Picker (Uncomment if needed) */}
        <div>
          <Space direction="vertical" size={12} style={{ marginBottom: "20px" }}>
            {/* <RangePicker disabledDate={disabledDate} /> */}
          </Space>
        </div>
      </Form>
    </Modal>
  );
};
